// components/MyPage/UserSettings.jsx
import { useState } from 'react';
import {
    Box, Tabs, Tab,
    Snackbar, Alert,
} from '@mui/material';

import UserInfoForm from './UserInfoForm';
import UserInfoForm2 from './UserInfoForm2';
import PasswordChangeForm from './PasswordChangeForm';

export default function UserSettings() {
    const [tab, setTab] = useState(0);
    const [snack, setSnack] = useState({
        open: false,
        msg: '',
        severity: 'success',
    });

    return (
        <Box sx={{ p: 2 }}>
            <Tabs
                value={tab}
                onChange={(_, v) => setTab(v)}
                variant="fullWidth"
                scrollButtons={false}
                sx={{ mb: 2 }}
            >
                <Tab label="회원정보 수정" />
                <Tab label="성향 설정" />
                <Tab label="비밀번호 변경" />
            </Tabs>

            {tab === 0 && <UserInfoForm setSnack={setSnack} />}
            {tab === 1 && <UserInfoForm2 setSnack={setSnack} />}
            {tab === 2 && <PasswordChangeForm setSnack={setSnack} />}

            {/* 중앙 고정 스낵바 */}
            <Snackbar
                open={snack.open}
                autoHideDuration={3000}
                onClose={() => setSnack((s) => ({ ...s, open: false }))}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                sx={{
                    '&.MuiSnackbar-root': {
                        top: '50% !important',
                        left: '50% !important',
                        transform: 'translate(-50%, -50%)',
                        //width: 'fit-content',
                        maxWidth: '90vw',
                        minWidth: 260,
                    },
                }}
            >
                <Alert
                    severity={snack.severity}
                    onClose={() => setSnack((s) => ({ ...s, open: false }))}
                    sx={{ width: '100%', '& .MuiAlert-message': { whiteSpace: 'pre-line' } }}
                >
                    {snack.msg}
                </Alert>
            </Snackbar>
        </Box>
    );
}
